<template>

    <div class="single-discount-container" v-wechat-title="'mysread'">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <!--頂部欄-->
        <div class="top-nav-container">
            <span>打折專區</span>
            <span @click="backClick" style="position: absolute;left: 10px">返回</span>
        </div>

        <div class="bookListContainer">
            <ul>
                <li v-for="book in discountList">
                    <img src="../assets/img_nine_discount.png" style="position: absolute;width: 10%" />
                    <img :src="book.pic1" alt="">
                    <span style="color: black;top: 10%;font-weight: bold">{{book.title}}</span>
                    <span style="top: 25%;color: #999999">作者：{{book.author}}</span>
                    <span style="top: 40%;color: #333333" class="book-dis">{{book.content}}</span>
                    <a @click="buyDiscountBook(book)">點擊購買</a>
                </li>
            </ul>
        </div>

        <div class="dialog" v-show="showBuyView">
            <div class="border">
                <h4>購買文包</h4>
                <p>(已購買章節不重復進行計算)</p>
                <p>原價：{{price1}}異幣</p>
                <p>折扣價：{{price2}}異幣</p>
                <div style="width: 100%;height: 1px;background-color: lightgray"></div>
                <div>
                    <a @click="cancel">取消</a>
                    <a @click="confirm">確定</a>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import axios from "axios";

export default {
    name: "SingleDiscountVue",
    data() {
        return {
            userId: "",
            discountList: [],
            isRequest: false,
            showBuyView: false,
            discountBookId: "",
            price1: "",
            price2: "",
        };
    },
    methods: {
        //返回
        backClick: function () {
            this.$router.go(-1);
        },

        //獲取打折書籍
        getDiscountBooks: function () {
            this.isRequest = true;
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getChosenDiscountList");
            params.append("type", "1");
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.discountList = res.data.data;
                } else {
                    alert(res.data.msg);
                }
            });
        },

        //購買
        buyDiscountBook: function (book) {
            this.discountBookId = book.id;
            this.price1 = book.originalPrice;
            this.price2 = book.price;
            this.showBuyView = true;
        },

        //取消
        cancel: function () {
            this.showBuyView = false;
        },

        //確定
        confirm: function () {
            if (this.userId !== null && this.userId !== "null") {
                this.isRequest = true;
                const params = new URLSearchParams();
                params.append("language", "zh-Hant");
                params.append("dev", "h5");
                params.append("uuid", "123456");
                params.append("ver", "1.0");
                params.append("ac", "buyDiscount9");
                params.append("bookId", this.discountBookId);
                params.append("uid", this.userId);
                this.$http.post(axios.baseURL, params).then((res) => {
                    this.isRequest = false;
                    this.showBuyView = false;
                    alert(res.data.msg);
                    if (res.data.status) {
                        this.getDiscountBooks();
                    }
                });
            } else {
                this.$router.push({
                    path: "LoginVue",
                });
            }
        },
    },
    created() {
        this.userId = localStorage.getItem("userId");
        this.getDiscountBooks();
    },
};
</script>

<style scoped>
.single-discount-container {
    max-width: 480px;
    min-height: 100vh;
    margin: 0 auto;
    border: 1px solid lightgoldenrodyellow;
}

.bookListContainer {
    margin-top: 50px;
    overflow-x: hidden;
}

.bookListContainer ul {
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    text-align: left;
}

.bookListContainer ul li {
    list-style: none;
    border-bottom: 1px solid gainsboro;
    position: relative;
    padding: 10px;
}

.bookListContainer ul li img {
    width: 20%;
}

.bookListContainer ul li span {
    width: 50%;
    position: absolute;
    margin-left: 22%;
    font-size: 14px;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
}

.bookListContainer ul li a {
    float: right;
    cursor: pointer;
    border: 1px solid gray;
    border-radius: 3px;
    padding: 3px 10px;
    background-color: white;
    color: deepskyblue;
}

.bookListContainer ul li a :active {
    background-color: gray;
}

.book-dis {
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-height: 20px;
    height: 60px;
    white-space: normal;
}

.dialog {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
}

.border {
    text-align: center;
    background-color: white;
    border-radius: 10px;
    width: 70%;
    height: 30%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.border h4 {
    margin-top: 20px;
}

.border p {
    font-size: 16px;
}

.border div {
    height: 60px;
    display: flex;
    flex-direction: row;
}

.border div a {
    line-height: 60px;
    width: 50%;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/SingleDiscountVue.vue